module.exports = __webpack_public_path__ + "static/media/NorthCarolinaAvatar.db8f9d42.png";